import * as React from 'react';
import core = egr.wcf.core;
import utils = egr.wcf.utils;
import { BaseComponent } from '../../BaseComponent';
import { OAPStoreState, OAPStore } from '../../../stores/OAPStore';
import { LayoutType } from '../../../constants/LayoutConstants';
import { ViewSettingsStore } from '../../../stores/ViewSettingsStore';
import { OAPActions } from '../../../actions/OAPActions';
import { SelectBoxOption } from '../../../stores/SelectBoxStore';
import { BasePopupMenuIcon } from '../BasePopupMenuIcon';
import { BasePopupMenuContent } from '../BasePopupMenuContent';
import { OverlayCloseButton } from '../../overlay/OverlayCloseButton';
import { ViewSettingsActions } from '../../../actions/ViewSettingsActions';

export interface OAPPopupState extends OAPStoreState {
    layoutType: LayoutType;
}

export class OAPActionsPopup extends BaseComponent<{}, OAPPopupState> {
    public componentWillMount(): void {
        this.addStoreListener(OAPStore, this.onChange);
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (this.state.actionOptions == null || this.state.actions.length === 0) {
            return null;
        }
        return (
            <div className="overlay-frame overlay-full"  style={this.state.actionOptions.displayMode === 'tile' ? {} : {background: 'transparent'}}>
                <div
                    style={{
                        width: '100%', height: '100%', display: 'block', zIndex: 1
                    }}
                    onClick={OAPActions.hideDialog}
                />
                {this.state.actionOptions.displayMode === 'tile' ? this.tiles() : this.list()}
            </div>
        );
    }

    protected onChange = (): void => {
        this.setState(jQuery.extend(
            {},
            OAPStore.getState(),
            {layoutType: ViewSettingsStore.getState().layoutType}
        ));
    };

    protected options = (): Array<SelectBoxOption> => {
        if (this.state.actions != null && this.state.actions.length > 0) {
            return this.state.actions.map((value, index) => {
                let className: string = '';
                let icon: JSX.Element | null = null;
                if (utils.string.isNotNullOrEmpty(value.image)) {
                    icon = <BasePopupMenuIcon src={value.image} key="icon"/>;
                } else {
                    className = ' egr-select-option-no-icon';
                }
                const extraButtons: Array<JSX.Element> = [];
                if (icon != null) {
                    extraButtons.push(icon);
                }
                return {
                    name: value.text || 'x',
                    key: index + '-o',
                    className: 'egr-select-option' + className,
                    callback: this.executeAction(value.execute),
                    extraButtons: extraButtons
                };
            });
        }

        return [];
    };

    protected list = (): JSX.Element => {
        const wrapperProps: React.HTMLProps<HTMLDivElement> = {};
        wrapperProps.style = {
            height: 10,
            left: this.state.position && this.state.position.left ? this.state.position.left : '50%',
            position: 'absolute',
            top: this.state.position && this.state.position.top ? this.state.position.top : '50%',
            transform: 'translate(-50%, -50%)',
            width: 10,
            zIndex: 2
        };
        return (
            <div {...wrapperProps}>
                <BasePopupMenuContent
                    transform={true}
                    defaultValue={null}
                    flagPosition={this.state.position.flagPosition}
                    open={true}
                    options={this.options()}
                />
            </div>
        );
    };

    protected tiles = (): JSX.Element | null => {
        const dialogStyle: React.CSSProperties = {};
        if (this.state.actionOptions == null) {
            return null;
        }
        switch (this.state.actionOptions.tileSize) {
            case 'medium':
                if (this.state.actions.length > 2) {
                    dialogStyle.width = 40 + 3 * 310 + 10;
                }
                break;
            case 'large':
                if (this.state.actions.length > 4) {
                    dialogStyle.width = 40 + 5 * 210;
                    dialogStyle.paddingRight = 10;
                }
                break;
            default:
                if (this.state.actions.length > 2) {
                    dialogStyle.width = 40 + 3 * 260 + 10;
                }
                break;
        }
        return (
            <div className="oap-actions-dialog" style={dialogStyle}>
                <OverlayCloseButton show={true} callback={OAPActions.hideDialog}/>
                {this.state.actions.map(this.getTile)}
            </div>
        );
    };

    protected getTile = (value: core.AppCallbacks.ChoiceAction, index: number): JSX.Element | null => {
        let size: number = 50;
        if (this.state.actionOptions == null) {
            return null;
        }
        switch (this.state.actionOptions.tileSize) {
            case 'medium':
                size = 100;
                break;
            case 'large':
                size = 200;
                break;
            default:
                size = 50;
                break;
        }

        const image: JSX.Element | null = value.image ? <img src={value.image} style={{maxWidth: size, maxHeight: size}}/> : null;
        const text: JSX.Element | null = value.text ? (<div className={'oap-action-label'}>{value.text}</div>) : null;

        return <div onClick={this.executeAction(value.execute)} key={index} className={'oap-action-tile-' + size}>{image}{text}</div>;
    };

    protected executeAction = (oapAction: () => Promise<void>) => async (): Promise<void> => {
        await ViewSettingsActions.withLock<void>(oapAction);
        OAPActions.hideDialog();
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/OAP/OAPActionsPopup.tsx